/** Список разрешений экрана для пакета {@link https://npmjs.com/package/vue-mq|vue-mq}
 * @name MQ_BREAKPOINTS
 */
const MQ_BREAKPOINTS = {
    MOBILE: 0,
    TABLET: 768,
    DESKTOP: 1024,
    INFINITY: 9999,

}

export {MQ_BREAKPOINTS}